<template>
  <validation-observer ref="observer" v-slot="{ invalid }">
    <form @submit.prevent="sendRegister">
      <v-expansion-panels
        class="mt-5"
        v-model="panel"
        :readonly="readonly"
        multiple
        accordion
      >
        <v-expansion-panel>
          <v-expansion-panel-header color="#007BC3" hide-actions>
            <b class="white--text">IDENTIFICAÇÃO</b>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pt-10 pb-0">
            <v-row>
              <v-col cols="4">
                <BaseInputValidation
                  id="email"
                  name="E-mail *"
                  rules="required|email"
                  v-model="form.email"
                  :disabled="me.record_source == 'invited' || me.email != false"
                ></BaseInputValidation>
              </v-col>
              <v-col cols="4">
                <BaseInputValidation
                  v-mask="['###.###.###-##', '##.###.###/####-##']"
                  id="employer_number"
                  name="CPF/CNPJ *"
                  rules="required"
                  v-model="form.employer_number"
                  :disabled="
                    me.record_source == 'invited' ||
                      form.employer_number != false
                  "
                ></BaseInputValidation>
              </v-col>
              <v-col cols="5">
                <BaseInputValidation
                  :disabled="
                    isCompanySearch || !hasPermissionToEdit || hideVisualizar()
                  "
                  :loading="isCompanySearch"
                  id="company_name"
                  name="Razão Social *"
                  rules="required"
                  v-model="form.company_name"
                ></BaseInputValidation>
              </v-col>
              <v-col cols="4">
                <BaseInputValidation
                  :disabled="
                    isCompanySearch ||
                      !hasPermissionToEdit ||
                      hideVisualizar() ||
                      hideVisualizar()
                  "
                  :loading="isCompanySearch"
                  id="trade_name"
                  :name="labelName + ' *'"
                  rules="required"
                  v-model="form.trade_name"
                ></BaseInputValidation>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header color="#007BC3" hide-actions>
            <b class="white--text">ENDEREÇO </b>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pt-10 pb-0">
            <v-row>
              <v-col cols="3">
                <BaseInputValidation
                  v-mask="['#####-###']"
                  :loading="isAddressSearch"
                  :disabled="
                    isAddressSearch || !hasPermissionToEdit || hideVisualizar()
                  "
                  id="zip_code"
                  name="CEP *"
                  rules="required"
                  v-model="form.address.zip_code"
                  icon="mdi-magnify"
                  @handleUp="handlerSearch"
                  @handlerAppendClick="handlerSearch"
                ></BaseInputValidation>
              </v-col>
              <v-col cols="4">
                <BaseInputValidation
                  :loading="isAddressSearch"
                  :disabled="
                    isAddressSearch || !hasPermissionToEdit || hideVisualizar()
                  "
                  id="state"
                  name="UF *"
                  rules="required"
                  maxlength="2"
                  v-model="form.address.state"
                ></BaseInputValidation>
              </v-col>
              <v-col cols="5">
                <BaseInputValidation
                  :loading="isAddressSearch"
                  :disabled="
                    isAddressSearch || !hasPermissionToEdit || hideVisualizar()
                  "
                  id="city"
                  name="Cidade *"
                  rules="required"
                  v-model="form.address.city"
                ></BaseInputValidation>
              </v-col>
              <v-col cols="4">
                <BaseInputValidation
                  :loading="isAddressSearch"
                  :disabled="
                    isAddressSearch || !hasPermissionToEdit || hideVisualizar()
                  "
                  id="neighborhood"
                  name="Bairro *"
                  rules="required|max:80"
                  v-model="form.address.neighborhood"
                ></BaseInputValidation>
              </v-col>
              <v-col cols="6">
                <BaseInputValidation
                  :loading="isAddressSearch"
                  :disabled="
                    isAddressSearch || !hasPermissionToEdit || hideVisualizar()
                  "
                  id="street"
                  name="Rua *"
                  rules="required|max:100"
                  v-model="form.address.street"
                ></BaseInputValidation>
              </v-col>
              <v-col cols="2">
                <BaseInputValidation
                  :disabled="!hasPermissionToEdit || hideVisualizar()"
                  id="number"
                  name="Número *"
                  rules="required|max:8"
                  v-model="form.address_number"
                ></BaseInputValidation>
              </v-col>
              <v-col cols="6">
                <BaseInputValidation
                  :disabled="!hasPermissionToEdit || hideVisualizar()"
                  id="complement"
                  name="Complemento"
                  rules="max:60"
                  v-model="form.address_complement"
                ></BaseInputValidation>
              </v-col>
              <v-col cols="5">
                <BaseInputValidation
                  :disabled="!hasPermissionToEdit || hideVisualizar()"
                  v-mask="['(##)#####-####', '(##)####-####']"
                  id="phone"
                  name="Telefone *"
                  rules="required"
                  v-model="form.phone"
                ></BaseInputValidation>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header color="#007BC3" hide-actions>
            <b class="white--text">OUTRAS INFORMAÇÕES </b>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pt-10 pb-0">
            <v-row>
              <v-col cols="4">
                <validation-provider
                  v-slot="{ errors }"
                  name="Classificação"
                  rules="required"
                >
                  <v-autocomplete
                    :disabled="!hasPermissionToEdit || hideVisualizar()"
                    v-model="form.classification"
                    :items="classifications"
                    item-text="name"
                    item-value="value"
                    outlined
                    :error-messages="errors"
                    label="Classificação *"
                  ></v-autocomplete>
                </validation-provider>
              </v-col>
              <v-col cols="6" v-if="$route.query.user_gfs_token">
                <validation-provider
                  v-slot="{ errors }"
                  name="Tipo de cliente/Fornecedor "
                  rules="required"
                >
                  <v-autocomplete
                    :disabled="hideVisualizar()"
                    v-model="form.client_type_id"
                    :items="clientTypes"
                    item-text="description"
                    item-value="id"
                    outlined
                    :error-messages="errors"
                    label="Tipo de cliente / Fornecedor *"
                  ></v-autocomplete>
                </validation-provider>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="verifyAuthorizationApprovation()">
          <v-expansion-panel-header color="#007BC3" hide-actions>
            <b class="white--text"
              >APROVAR O CADASTRO NO RM E LIBERAR ACESSO A ESTE FORNECEDOR
            </b>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pt-10 pb-0">
            <v-row>
              <v-col>
                <label for="row">Aprovado?</label>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="Aprovado?"
                >
                  <v-radio-group
                    :disabled="hideVisualizar()"
                    v-model="form.status_register"
                    row
                    :error-messages="errors"
                  >
                    <v-radio
                      :disabled="hideVisualizar()"
                      label="SIM"
                      value="approved"
                    ></v-radio>
                    <v-radio
                      :disabled="hideVisualizar()"
                      label="NÃO"
                      value="disapproved"
                    ></v-radio>
                  </v-radio-group>
                </validation-provider>
              </v-col>
              <v-col cols="12" v-if="form.status_register === 'disapproved'">
                <validation-provider
                  v-slot="{ errors }"
                  name="Motivo"
                  rules="required"
                >
                  <v-textarea
                    v-model="form.note"
                    outlined
                    :error-messages="errors"
                    chips
                    small-chips
                    label="Motivo *"
                    :disabled="hideVisualizar()"
                  ></v-textarea>
                </validation-provider>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-col cols="12" justify="center" align="center">
        <v-btn
          v-if="hideVisualizar() || $route.name == 'register'"
          id="back"
          text
          large
          rounded
          color="#444444"
          class="mr-4"
          @click="back()"
        >
          VOLTAR
        </v-btn>
        <v-btn
          id="back"
          v-if="!hideVisualizar() && !$route.name == 'register'"
          text
          large
          rounded
          color="#444444"
          class="mr-4"
          @click="back()"
        >
          {{
            $route.query.user_gfs_token ? "CANCELAR" : "&lt; &lt; &nbsp;VOLTAR"
          }}
        </v-btn>
        <v-btn
          v-if="!hideVisualizar()"
          :loading="loading"
          id="submit"
          style="color: white"
          rounded
          large
          color="#0894C0"
          class="mr-4"
          type="submit"
          :disabled="invalid"
        >
          {{ $route.query.user_gfs_token ? "SALVAR" : "CONFIRMAR" }}
        </v-btn>
      </v-col>
    </form>
    <v-dialog v-model="isActiveAddressModal" width="800" hide-overlay>
      <v-card>
        <Addresses
          @selectedCep="selectedCep($event)"
          @close="isActiveAddressModal = $event"
        ></Addresses>
      </v-card>
    </v-dialog>
  </validation-observer>
</template>

<script>
import _ from "lodash";
import { email, required } from "vee-validate/dist/rules";
import { mapGetters, mapActions } from "vuex";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from "vee-validate";
import { mask } from "vue-the-mask";
import clone from "lodash/clone";
import Jwt from "../../../api/jwt";

import BaseInputValidation from "../../../components/UI/BaseInputValidation";

import Addresses from "../../addresses";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "Favor informar {_field_}."
});

extend("email", {
  ...email,
  message: "E-mail inválido."
});

export default {
  name: "RegisterProviderForm",
  components: {
    ValidationProvider,
    ValidationObserver,
    BaseInputValidation,
    Addresses
  },
  directives: { mask },
  data: () => ({
    clientTypeId: "",
    hasPermissionToView: false,
    hasPermissionToEdit: true,
    isUserGfs: false,
    isAddressSearch: false,
    isCompanySearch: false,
    loading: false,
    isRm: false,
    labelName: "Nome Fantasia",
    isActiveAddressModal: false,
    classifications: [
      {
        name: "Cliente",
        value: "client"
      },
      {
        name: "Fornecedor",
        value: "provider"
      },
      {
        name: "Ambos",
        value: "both"
      }
    ],
    form: {
      email: "",
      employer_number: "",
      trade_name: "",
      company_name: "",
      address_number: "",
      user_gfs_id: "",
      user_gfs_nm: "",
      phone: "",
      classification: "",
      address_complement: "",
      address: {
        zip_code: "",
        neighborhood: "",
        city: "",
        state: "",
        street: "",
        codmunicipio: ""
      },
      validation: {
        isApproved: false,
        note: ""
      }
    },
    panel: [0, 1, 2, 3],
    readonly: false
  }),
  computed: {
    ...mapGetters({
      me: "$_auth/me",
      meInGfs: "$_auth/meInGfs",
      rmProvider: "$_rmProvider/provider",
      addressOnViacep: "$_address/addressOnViacep",
      clientTypes: "$_clientTypes/all",
      provider: "$_provider/provider",
      providers: "$_provider/providers"
    })
  },
  props: {
    isInitialRegister: {
      type: Boolean,
      default: true
    },
    isValidated: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions({
      searchZipCode: "$_address/showAddressOnViaCep",
      meInGfsAction: "$_auth/meInGfs",
      logout: "$_auth/logout",
      providerStore: "$_provider/store",
      providerUpdateAndValidate: "$_provider/updateAndValidate",
      providerUpdate: "$_provider/update",
      preRegisterFinished: "$_auth/preRegisterFinished",
      clientTypesIndex: "$_clientTypes/index"
    }),
    hideVisualizar() {
      if (this.$route.name === "visualizar") {
        return true;
      }
      return false;
    },
    async submit() {
      this.loading = true;
      this.form.address.zip_code = this.form.address.zip_code.replace(
        /[^0-9]/g,
        ""
      );
      this.form.phone = this.form.phone.replace(/[^0-9]/g, "");
      this.form.employer_number = this.form.employer_number.replace(
        /[^0-9]/g,
        ""
      );
      try {
        if (this.providers.length > 0) {
          if (!this.$route.query.user_gfs_token) {
            const providerId = this.providers[0].id;
            await this.providerUpdate({
              body: this.form,
              id: providerId
            });
            await this.preRegisterFinished({ provider_id: providerId });
            await this.$store.dispatch(`$_messages/setErrors`, {
              message: `Parabéns seu cadastro foi enviado para aprovação, enviamos um email para você com o proximo passo.`,
              type: "success",
              title: "Success!",
              timeout: 12000
            });
          } else {
            await this.providerUpdateAndValidate({
              body: this.form,
              id: this.providers[0].id
            });

            if (this.form.status_register === "approved") {
              await this.$store.dispatch(`$_messages/setErrors`, {
                message: `Foi enviado um email com login e senha para o Fornecedor.`,
                type: "success",
                title: "Success!",
                timeout: 12000
              });
            } else {
              await this.$store.dispatch(`$_messages/setErrors`, {
                message: `Foi enviado um email informando ao fornecedor que o cadastro foi reprovado.`,
                type: "success",
                title: "Success!",
                timeout: 12000
              });
            }
          }
        } else {
          const provider = await this.providerStore(this.form);
          await this.preRegisterFinished({ provider_id: provider.id });
          await this.$store.dispatch(`$_messages/setErrors`, {
            message: `Parabéns seu cadastro foi enviado para aprovação, enviamos um email para você com o proximo passo.`,
            type: "success",
            title: "Success!",
            timeout: 12000
          });
        }
        this.loading = false;
        await this.sendRegister();
        this.$store.commit("$_auth/DELETE_ME_AUTHENTICATED");
        this.$router.push("/autenticacao");
      } catch (error) {
        this.loading = false;
        const message = error.response.data.message;
        await this.$store.dispatch(`$_messages/setErrors`, {
          message:
            message ??
            `Houve algum problema no cadastro da sua empresa favor entre em contato com o suporte.`,
          type: "error",
          title: "Error!",
          timeout: 8000
        });
      }
    },

    async sendRegister() {
      var message = "";

      if (this.form.status_register === "approved") {
        message =
          " Os dados cadastrais do fornecedor serão gravados no sistema RM e as " +
          "credenciais de acesso ao portal do fornecedor serão enviadas por " +
          "e-mail. Esta operação pode demorar em média 30 segundos, " +
          "aproximadamente. Confirma?";
      }

      if (!this.$route.query.user_gfs_token) {
        message = "Deseja finalizar o cadastro?";
      }

      await this.$store.dispatch("$_notifications/setAlert", {
        message:
          message ??
          "Um e-mail de reprovação do cadastro do fornecedor será enviado. Confirma a operação?",
        cancelTitle: "Não",
        actions: [
          {
            title: "Sim",
            action: this.submit
          }
        ]
      });
    },

    async handlerSearch(e) {
      if (e.pointerId) this.isActiveAddressModal = true;
      if (this.form.address.zip_code.length === 9) {
        this.isAddressSearch = true;
        await this.searchZipCode(
          this.form.address.zip_code.replace(/[^0-9]/g, "")
        );
        this.setAddressFields();
        this.isAddressSearch = false;
      }
    },
    setAddressFields() {
      this.form.address.neighborhood = this.addressOnViacep.bairro;
      this.form.address.street = this.addressOnViacep.logradouro;
      this.form.address.city = this.addressOnViacep.localidade;
      this.form.address.state = this.addressOnViacep.uf;
      this.form.address.codmunicipio = this.addressOnViacep.codmunicipio;
    },

    async setFormWithRM() {
      this.form.email = clone(this.me.email);
      this.form.user_id = clone(this.me.id);
      this.form.employer_number =
        clone(this.rmProvider.cgccfo) ||
        clone(this.$route.query.employer_number) ||
        clone(this.me.providers[0].employer_number);
      this.form.company_name = clone(this.rmProvider.nome);
      this.form.trade_name = clone(this.rmProvider.nomefantasia);
      this.form.address = {
        zip_code: clone(this.rmProvider.cep),
        neighborhood: clone(this.rmProvider.bairro),
        city: clone(this.rmProvider.cidade),
        state: clone(this.rmProvider.codetd),
        street: clone(this.rmProvider.rua),
        codmunicipio: clone(this.rmProvider.codmunicipio)
      };
      this.form.address_number = clone(this.rmProvider.numero);
      this.form.address_complement = clone(this.rmProvider.complemento);
      this.form.phone = clone(this.rmProvider.telefone);
      this.form.rm_id = clone(this.rmProvider.codcfo);
    },

    async setFieldName(employerNumber) {
      if (employerNumber.length >= 14) {
        this.employerType = "CNPJ";
        this.labelName = "Nome Fantasia";
      } else {
        this.employerType = "CPF";
        this.labelName = "Nome";
      }
    },
    async setFormWithMe() {
      var employerNumber = "";
      if (this.$route.query.employer_number) {
        employerNumber = this.$route.query.employer_number.replace(
          /[^0-9]/g,
          ""
        );
      } else {
        employerNumber = this.me.providers[0].employer_number;
      }
      if (this.employerType === "CPF") {
        employerNumber = employerNumber.padStart(11, 0);
      } else {
        employerNumber = employerNumber.padStart(14, 0);
      }

      await this.$store.dispatch(`$_provider/index`, {
        employer_number: employerNumber,
        limit: -1
      });
      this.form.email = clone(this.me.email || this.providers[0].email);
      this.form.user_id = clone(this.me.id);
      this.form.employer_number = clone(
        this.$route.query.employer_number ||
          this.me.providers[0].employer_number
      );

      if (this.employerType === "CPF") {
        this.form.employer_number = this.form.employer_number.padStart(11, 0);
      } else {
        this.form.employer_number = this.form.employer_number.padStart(14, 0);
      }
      if (this.providers[0].addresses) {
        this.form.address = clone(this.providers[0].addresses);
      }
      this.form.address_complement = clone(
        this.providers[0].address_complement
      );
      this.form.address_number = clone(this.providers[0].address_number);
      this.form.phone = clone(this.providers[0].phone);
      this.form.company_name = clone(this.providers[0].company_name);
      this.form.trade_name = clone(this.providers[0].trade_name);
      this.form.classification = clone(this.providers[0].classification);
    },
    async checkRoleGfsUser() {
      this.meInGfs.perfil.forEach(role => {
        role.funcionalidade.forEach(feature => {
          if (feature.ds_rota === "gerenciar.index") {
            let index = feature.acao.filter(action => {
              if (action.ds_acao_permissao === "index") {
                return true;
              }
            });
            let edit = feature.acao.filter(action => {
              if (action.ds_acao_permissao === "edit") {
                return true;
              }
            });

            this.hasPermissionToView = index.length > 0;
            this.hasPermissionToEdit = edit.length > 0;
          }
        });
      });
    },
    selectedCep(address) {
      this.form.address = {
        zip_code: address.cep,
        neighborhood: address.bairro,
        city: address.localidade,
        state: address.uf,
        street: address.logradouro,
        codmunicipio: address.codmunicipio
      };
    },
    verifyAuthorizationApprovation() {
      return (
        this.$route.query.user_gfs_token &&
        _.hasIn(this.providers[0], "status_register") &&
        this.providers[0].status_register !== "approved"
      );
    },
    async back() {
      if (
        this.$route.query.user_gfs_token ||
        _.hasIn(this.$route, "query.passo")
      ) {
        await this.$store.dispatch(`$_auth/logout`);
        this.$store.commit("$_auth/DELETE_ME_AUTHENTICATED");
        this.$router.push("/autenticacao");
      } else {
        this.$router.push({ name: "modules" });
      }
    }
  },

  async mounted() {
    this.isRm = Object.prototype.hasOwnProperty.call(this.rmProvider, "nome")
      ? true
      : false;

    if (this.isRm) this.setFormWithRM();
  },

  async created() {
    if (this.$route.query.user_gfs_token) {
      Jwt.saveToken(this.$route.query.user_gfs_token);
      await this.clientTypesIndex();
      // await Jwt.destroyToken();
      try {
        await this.meInGfsAction({ token: this.$route.query.user_gfs_token });
        this.form.user_gfs_id = this.meInGfs.cd_usuario;
        this.form.user_gfs_nm = this.meInGfs.nm_usuario;
        await this.$store.dispatch(`$_messages/setErrors`, {
          message: `Logado(a) como ${this.meInGfs.nm_usuario}.`,
          type: "success",
          title: "Sucesso!",
          timeout: 4000
        });
        this.isUserGfs = true;
        await this.checkRoleGfsUser();
        if (
          !this.hasPermissionToView ||
          (!this.hasPermissionToView && !this.hasPermissionToEdit)
        ) {
          await this.$store.dispatch(`$_messages/setErrors`, {
            message: `Você não tem PERFIL para visualizar essa tela. Solicite ao administrador do GFS para conceder o acesso.`,
            type: "error",
            title: "Sucesso!",
            timeout: 8000
          });
          this.$router.push("/");
        }
      } catch (error) {
        console.log(error);
        await this.$store.dispatch(`$_messages/setErrors`, {
          message: `Esse link expirou ou é invalido.`,
          type: "error",
          title: "Sucesso!",
          timeout: 4000
        });
        this.$router.push("/");
      }
    }
    if (this.$route.query.token) {
      Jwt.saveToken(this.$route.query.token);

      if (Jwt.getToken()) {
        try {
          await this.$store.dispatch(`$_auth/me`);
          if (this.$route.query.employer_number) {
            await this.$store.dispatch(
              `$_rmProvider/show`,
              this.$route.query.employer_number.replace(/[^0-9]/g, "")
            );
            if (
              Object.prototype.hasOwnProperty.call(this.rmProvider, "codcfo")
            ) {
              await this.setFormWithRM();
            }
          }
        } catch (error) {
          console.log(error);
          await this.$store.dispatch(`$_messages/setErrors`, {
            message:
              "Este link já foi utilizado anteriormente e o CPF/CNPJ já está em processo de cadastramento.",
            type: "error",
            title: "Sucesso!",
            timeout: 8000
          });
          this.$router.push({ name: "auth.login" });
        }
      }
    }
    if (this.$route.query.token) {
      try {
        this.form.email = this.me.email;
        this.form.employer_number = this.me.providers[0].employer_number;
        if (this.me.providers[0].employer_number) {
          try {
            this.isCompanySearch = true;
            await this.$store.dispatch(`$_provider/index`, {
              employer_number: this.me.providers[0].employer_number,
              limit: -1
            });
            await this.$store.dispatch(
              `$_rmProvider/show`,
              this.me.providers[0].employer_number
            );

            this.setFieldName(this.me.providers[0].employer_number);
            if (this.rmProvider.length === 0) {
              await this.setFormWithMe();
            } else {
              await this.setFormWithRM();
            }
            this.isCompanySearch = false;
          } catch (error) {
            console.log(error);
            await this.$store.dispatch(`$_messages/setErrors`, {
              message:
                "Erro interno. Favor entrar em contato com o suporte. Informar o codigo 408.",
              type: "error",
              title: "Error!",
              timeout: 8000
            });
          }
        }
      } catch (error) {
        console.log(error);
        await this.$store.dispatch(`$_messages/setErrors`, {
          message:
            "Este link já foi utilizado anteriormente e o CPF/CNPJ já está em processo de cadastramento.",
          type: "error",
          title: "Sucesso!",
          timeout: 8000
        });
        this.$router.push({ name: "auth.login" });
      }
    } else if (this.$route.query.user_gfs_token) {
      let employerNumber = this.$route.query.employer_number;
      await this.$store.dispatch(`$_provider/index`, {
        employer_number: employerNumber.replace(/[^0-9]/g, ""),
        limit: -1
      });
      await this.$store.dispatch(
        `$_rmProvider/show`,
        employerNumber.replace(/[^0-9]/g, "")
      );
      if (Object.prototype.hasOwnProperty.call(this.rmProvider, "codtcf")) {
        let clientType = this.clientTypes.filter(element => {
          return this.rmProvider.codtcf === element.id_rm;
        });
        this.clientTypeId = clientType[0].id;
      }
      if (this.providers[0].status_register !== "disapproved") {
        this.hasPermissionToEdit = true;
      }
      if (this.providers[0].status_register === "disapproved") {
        this.form.note = clone(this.providers[0].providers_register.note);
        this.form.status_register = clone(this.providers[0].status_register);
      }
      if (!this.providers[0].status_register) {
        this.form.status_register = clone(this.providers[0].status_register);
      }

      this.form.email = clone(this.me.email || this.providers[0].email);
      this.form.user_id = clone(this.me.id);
      this.form.employer_number = clone(employerNumber);
      this.form.address = clone(this.providers[0].addresses);
      this.form.address_complement = clone(
        this.providers[0].address_complement
      );
      this.form.address_number = clone(this.providers[0].address_number);
      this.form.phone = clone(this.providers[0].phone);
      this.form.company_name = clone(this.providers[0].company_name);
      this.form.trade_name = clone(this.providers[0].trade_name);
      this.form.classification = clone(this.providers[0].classification);
      this.form.client_type_id = clone(
        parseInt(this.providers[0].client_type_id) || this.clientTypeId
      );
    } else {
      this.form.email = clone(this.me.email);
      this.form.user_id = clone(this.me.id);
      this.form.employer_number =
        clone(this.rmProvider.cgccfo) ||
        clone(this.$route.query.employer_number);
    }
  },

  watch: {
    "form.status_register"() {
      this.form.note = "";
    }
  }
};
</script>
